module.exports = __webpack_public_path__ + "img/20.300ffd87.jpg";